export default __webpack_public_path__ + "static/media/notification-pause.64f8fb96.svg";